import { QrCodePage } from "@/components/QrCodePage";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export function QrCodeGiroPage() {
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!state) {
            navigate("/compra/titulos?tab=giro");
        }
    }, [state, navigate]);

    if (!state) {
        return null;
    }

    return <QrCodePage />;
}
